module.exports = __webpack_public_path__ + "img/icon-tip.128d1230.png";